import { resolveLinkName, trackClick } from '../tracking';
import { EVENT_NAMES } from '../types/base';
import type {
  ICalculatorInitiatedInput,
  ICalculatorSubmittedInput,
} from '../types/clickEvents';
import type { IFinanceLeadInitiationInput } from '../types/leadEvents';

export const handleFinanceLeadInitiation = ({
  event,
  linkDetails,
  leadOriginationPage,
  leadType,
  step,
}: IFinanceLeadInitiationInput) => {
  trackClick(EVENT_NAMES.financeLeadInitiation, {
    linkDetails: {
      ...linkDetails,
      linkName: resolveLinkName(event, linkDetails?.linkName) ?? '',
    },
    leadOriginationPage,
    leadType,
    step,
  });
};

export const handleCalculatorInitiated = ({
  event,
  linkDetails,
  moduleName,
}: ICalculatorInitiatedInput) => {
  trackClick(EVENT_NAMES.calculatorInitiated, {
    linkDetails: {
      ...linkDetails,
      linkName: resolveLinkName(event, linkDetails?.linkName) ?? '',
    },
    moduleName,
  });
};

export const handleCalculatorSubmitted = ({
  event,
  linkDetails,
  financeCalculator,
  moduleName,
}: ICalculatorSubmittedInput) => {
  trackClick(EVENT_NAMES.calculatorSubmitted, {
    linkDetails: {
      ...linkDetails,
      linkName: resolveLinkName(event, linkDetails?.linkName) ?? '',
    },
    financeCalculator,
    moduleName,
  });
};
